// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"623763ab","189":"a34e0510","207":"1e0fd45e","328":"dacade97","421":"2cbc4d5b","453":"c3e71834","689":"fef75fb1","691":"71141788","692":"c4f18e10","787":"69c5fbc5","800":"8251d65f","824":"cb1ad730","999":"55a69121"}[chunkId] + ".chunk.js";
};